var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.key,
      style: _vm.categorie ? "background-color:" + _vm.categorie.couleur : ""
    },
    [
      _vm.enChargement
        ? _c(
            "div",
            {
              staticClass: "composante-container",
              staticStyle: { "text-align": "center" }
            },
            [
              _c("img", {
                staticStyle: { height: "80px", "margin-left": "-8px" },
                attrs: {
                  alt: "en attente",
                  src: "/assets/images/spinners/cooking-blue-court.gif"
                }
              })
            ]
          )
        : _vm.composante.categorieGEMRCNId
        ? _c("div", { staticClass: "composante-container" }, [
            _c("div", { staticClass: "flex-center-space-between" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    height: "16px",
                    overflow: "hidden",
                    "white-space": "nowrap"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      style:
                        "cursor:default;" +
                        (_vm.categorie
                          ? "color:" +
                            _vm.couleurTexte(
                              _vm.categorie.couleur,
                              "#6F6F6F",
                              "#BFBFBF"
                            )
                          : "")
                    },
                    [_vm._v(_vm._s(_vm.composante.nom))]
                  )
                ]
              ),
              _c("div", { staticStyle: { "white-space": "nowrap" } }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: { content: "Changer la catégorie" },
                        expression: "{ content: 'Changer la catégorie'}"
                      }
                    ],
                    staticClass: "btn btn-primary",
                    staticStyle: {
                      padding: "0 4px",
                      "border-radius": "8px",
                      transform: "scale(0.7)",
                      "margin-right": "-5px"
                    },
                    attrs: { type: "button" },
                    on: { click: _vm.afficherModalCategories }
                  },
                  [_c("i", { staticClass: "fas fa-exchange-alt" })]
                ),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: { content: "Effacer la catégorie" },
                        expression: "{ content: 'Effacer la catégorie'}"
                      }
                    ],
                    staticClass: "btn btn-danger",
                    staticStyle: {
                      padding: "0 6.5px",
                      "border-radius": "8px",
                      "margin-left": "4px",
                      transform: "scale(0.7)"
                    },
                    attrs: { type: "button" },
                    on: { click: _vm.effacerCategorie }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ])
            ]),
            _c(
              "div",
              {
                staticClass: "flex-center-space-between",
                staticStyle: { "align-items": "flex-start" }
              },
              [
                _c("div", [
                  _c(
                    "div",
                    {
                      style:
                        "height:45px;font-size:12px;" +
                        (_vm.categorie
                          ? "color:" +
                            _vm.couleurTexte(
                              _vm.categorie.couleur,
                              "black",
                              "white"
                            )
                          : "")
                    },
                    [
                      _c("div", [
                        _vm._v(
                          " " + _vm._s(_vm.categorie && _vm.categorie.nom) + " "
                        )
                      ])
                    ]
                  )
                ])
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  position: "absolute",
                  bottom: "0",
                  width: "100%",
                  left: "0"
                }
              },
              _vm._l(_vm.limites, function(limite, iLimite) {
                return _c("div", { key: iLimite }, [
                  _c(
                    "div",
                    {
                      class:
                        "pl-1 " +
                        (limite.compte >= limite.frequenceMin &&
                        (!limite.frequenceMax ||
                          limite.compte <= limite.frequenceMax)
                          ? "bg-success"
                          : "bg-danger")
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(limite.compte) +
                          " (" +
                          _vm._s(limite.texteAAfficher) +
                          ") "
                      )
                    ]
                  )
                ])
              }),
              0
            )
          ])
        : _c("div", { staticClass: "composante-container" }, [
            _c(
              "div",
              {
                style:
                  "color:" + _vm.couleurTexte("#000000", "#6F6F6F", "#BFBFBF")
              },
              [_vm._v(_vm._s(_vm.composante.nom))]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-ajouter",
                attrs: {
                  type: "button",
                  title: "Ajouter une catégorie GEMRCN"
                },
                on: { click: _vm.afficherModalCategories }
              },
              [_c("i", { staticClass: "fas fa-plus" }), _vm._v(" Ajouter")]
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }